import {Component, OnInit, ViewChild} from '@angular/core';
import {Institution, InstService} from "../../services/inst.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {finalize} from "rxjs/operators";
import {UtilService} from "../../services/util.service";
import {StateService} from "../../services/state.service";
import {Router} from "@angular/router";

@Component({
    templateUrl: './institutions.component.html',
    styleUrls: ['./institutions.component.css']
})
export class InstitutionsComponent implements OnInit {

    readonly columnsToDisplay = ['name', 'type', 'contactEmail', 'contactName', 'promoPrefix', 'actions'];
    readonly INITIAL_PAGE_INDEX = 0;
    readonly INITIAL_PAGE_SIZE = 10;

    @ViewChild('paginator') paginator: MatPaginator;
    updating: boolean = false;
    institutions: Institution[] = [];
    instRange: Institution[] = [];

    constructor(private instService: InstService,
                private state: StateService,
                private router: Router,
                private utilService: UtilService) {
    }

    ngOnInit() {
        this.refresh();
    }

    private refresh() {
        this.updating = true;
        this.instService.getAll().pipe(
            finalize(() => {this.updating=false})
        ).subscribe((institutions) => {
            this.institutions = institutions;
            this.updateInstRange();
        }, this.utilService.getErrorHandler("Error retrieving orders"));
    }

    private updateInstRange() {
        const pageSize = this.paginator? this.paginator.pageSize : this.INITIAL_PAGE_SIZE;
        const pageIndex = this.paginator? this.paginator.pageIndex : this.INITIAL_PAGE_INDEX;
        const offset = pageIndex * pageSize;
        this.instRange = this.institutions.slice(offset, offset + pageSize);
    }

    pageChanged(ev: PageEvent) {
        this.updateInstRange();
    }

    edit(inst: Institution) {
        this.state.set('institution', inst);
        this.router.navigateByUrl('/institution').then();
    }

    orders(inst: Institution) {
        this.state.set('institution', inst);
        this.router.navigateByUrl('/institution/orders').then();
    }

    addNew() {
        this.state.clear("institution");
        this.router.navigateByUrl('/institution').then();
    }

    back() {
        this.router.navigateByUrl('/').then();
    }
}
